/**
 * Auto-fetch SMSWiser drops when a complete date range is selected or changed.
 * For Media Devoted | Created By Ciro Autiero
 */

import { useEffect } from 'react';

import { DROPS_FETCH_LENGTH_DEFAULT } from '@trafficpulse/shared';

import {
  getSuggestedDropsFetchLength,
  resolveDropsFetchLength,
} from '@/features/drops/utils/resolveDropsFetchLength';

interface UseAutoFetchDropsOnDateRangeParams {
  dateFrom: string;
  dateTo: string;
  fetchedRange: { from: string; to: string };
  setFetchLength: (value: number) => void;
  setFetchLengthDraft: (value: number) => void;
  setFetchedRange: (value: { from: string; to: string }) => void;
  setPage: (page: number) => void;
}

export function useAutoFetchDropsOnDateRange(
  params: UseAutoFetchDropsOnDateRangeParams,
): void {
  const {
    dateFrom,
    dateTo,
    fetchedRange,
    setFetchLength,
    setFetchLengthDraft,
    setFetchedRange,
    setPage,
  } = params;

  useEffect(() => {
    if (!dateFrom || !dateTo) {
      if (fetchedRange.from || fetchedRange.to) {
        setFetchedRange({ from: '', to: '' });
        setFetchLength(DROPS_FETCH_LENGTH_DEFAULT);
        setFetchLengthDraft(DROPS_FETCH_LENGTH_DEFAULT);
      }
      return;
    }

    const suggested = getSuggestedDropsFetchLength(dateFrom, dateTo);
    setFetchLengthDraft(suggested);

    if (fetchedRange.from === dateFrom && fetchedRange.to === dateTo) {
      return;
    }

    const effectiveLength = resolveDropsFetchLength({
      manualLength: suggested,
      dateFrom,
      dateTo,
    });
    setFetchLength(effectiveLength);
    setFetchLengthDraft(effectiveLength);
    setFetchedRange({ from: dateFrom, to: dateTo });
    setPage(1);
  }, [
    dateFrom,
    dateTo,
    fetchedRange.from,
    fetchedRange.to,
    setFetchLength,
    setFetchLengthDraft,
    setFetchedRange,
    setPage,
  ]);
}
